var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"head"},[_c('div',{staticClass:"bg"}),_c('span',[_vm._v(" "+_vm._s(_vm.shopName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }